function init() {
  const navigation = document.querySelector('.js-navigation');
  if (!navigation) {
    return;
  }
  const menu = document.querySelector('.js-menu');
  const expandables = navigation.querySelectorAll('.js-navigation__expand');
  const pageBanner = document.querySelector('.js-pageBanner');
  const closedPageBanner = sessionStorage.getItem('closedPageBanner');
  const parentItems = navigation.querySelectorAll('.navigation__item[data-items]');
  const overlay = document.getElementById('navigation__overlay');
  const html = document.documentElement;
  const body = html.querySelector('body');
  const animationDuration = getComputedStyle(document.documentElement).getPropertyValue('--navigation-slide-duration');
  let slideAnimation;
  let scrollPosition;

  const showOverlay = () => {
    overlay.classList.add('navigation__overlay--visible');
  };

  const hideOverlay = () => {
    overlay.classList.remove('navigation__overlay--visible');
  };

  const getExpanded = (elem) => {
    return elem.getAttribute('aria-expanded') === 'true' || false;
  };

  menu.addEventListener('click', () => {
    const expanded = getExpanded(menu);
    let menuActionText = menu.dataset.eventaction;

    menu.setAttribute('aria-expanded', !expanded);
    window.clearTimeout(slideAnimation);

    if (!closedPageBanner && pageBanner) {
      pageBanner.style.display = !expanded ? 'none' : 'block';
    }

    if (!expanded) {
      scrollPosition = window.pageYOffset;
      html.classList.add('nav-open');
      body.style.top = `-${scrollPosition}px`;
      menuActionText = menuActionText.replace('Close', 'Open');
      navigation.classList.add('navigation--open');
      navigation.classList.remove('navigation--sliding');
    } else {
      menuActionText = menuActionText.replace('Open', 'Close');
      navigation.classList.add('navigation--sliding');

      slideAnimation = window.setTimeout(() => {
        navigation.classList.remove('navigation--open', 'navigation--sliding');
      }, parseFloat(animationDuration) * 1000);
      html.classList.remove('nav-open');
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollPosition);
      html.style.removeProperty('scroll-behavior');
    }

    menu.dataset.eventaction = menuActionText;
  });

  parentItems.forEach((item) => {
    item.addEventListener('mouseenter', showOverlay);
    item.addEventListener('mouseleave', hideOverlay);
    item.addEventListener('focus', showOverlay, true);
    item.addEventListener('blur', hideOverlay, true);
  });

  expandables.forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = getExpanded(button);
      let menuActionText = button.dataset.eventaction;

      button.setAttribute('aria-expanded', !expanded);
      button.parentElement.toggleAttribute('open', !expanded);

      if (!expanded) {
        menuActionText = menuActionText.replace('Close', 'Open');
      } else {
        menuActionText = menuActionText.replace('Open', 'Close');
      }

      button.dataset.eventaction = menuActionText;
    });
  });
}

export { init };
